/**
 * Inject a <style> block once per id (web only). Motion primitives keep their
 * CSS next to the component, like EdgeLine does, so each one ships complete.
 */
const injected = new Set();

export default function injectCss(id, css) {
    if (injected.has(id) || typeof document === 'undefined') return;
    injected.add(id);
    const el = document.createElement('style');
    el.setAttribute('data-bo-css', id);
    el.textContent = css;
    document.head.appendChild(el);
}
